import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Button,  Typography } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import UploadButton from '../../../components/Button/UploadButton';
import ButtonCustom from '../../../components/Button/ButtonCustom';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import FileCard from '../../../components/Card/FileCard';
import CopyToClipboard from 'react-copy-to-clipboard';
import { MODE } from '../../../constants/form-mode';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import HorizontalFileCard from '../../../components/Card/HorizontalFileCard';

const PDFCard = ({
    title,
    publicLink="",
    file,
    handleOpenSignatories,
    handleDownloadFile,
    handleUploadFile,
    handleShareFile,
    handleViewFile,
    handleCopyLink,
    handleRemoveFile,
    handleMarkSharing,
    signButtonLabel,
    fileIcon = process.env.PUBLIC_URL + '/assets/image/default_ico.png', //default
    formMode,
    sharedForms,
    onSharedView=false,
    layout="VERTICAL",
    isFileExists
}) => {
    const [fileExists, setFileExists] = useState(null);

    useEffect(() => {
        if(isFileExists){
            const checkFile = async () => {
                const result = await isFileExists(file); // Check if the file exists
                setFileExists(result); // Store the result in state
            };
    
            checkFile(); // Run the check when the component mounts or when `file` changes
        }
    }, [ isFileExists]); // Dependency array to re-check if `file` changes
    
    return (
        <>
            {layout === "VERTICAL" ?
                <FileCard
                    key={title}
                    imageSrc={fileIcon}
                    onRemoveItem={handleRemoveFile}
                // openCard={() => alert('clicked')}
                >
                    <Typography variant="body1" sx={{ textAlign: "center", mb: 2 }} gutterBottom >
                        {title}
                    </Typography>
                    {handleDownloadFile &&
                        <ButtonCustom
                            label={'Download'}
                            sx={{
                                width: formMode === MODE.CLOSED ? '280px' : "33%",
                                borderRadius: '20px', textDecoration: "underline",
                                my: 1, mr: formMode === MODE.CLOSED ? 0 : 1,
                                fontSize: 9
                            }}
                            startIcon={< DownloadOutlinedIcon />}
                            variant="outlined"
                            color="error"
                            onClickBtn={handleDownloadFile}
                        />

                    }
                    {formMode !== MODE.CLOSED
                        &&
                        <>
                            {handleViewFile &&

                                <ButtonCustom
                                    label={'View'}
                                    sx={{
                                        width: onSharedView ? '47%' : '48%',
                                        borderRadius: '20px', my: 1, mr: 1,
                                        fontSize: 11,
                                    }}
                                    startIcon={<FileOpenOutlinedIcon />}
                                    variant="outlined"
                                    onClickBtn={handleViewFile}
                                />
                            }
                            {handleUploadFile &&
                                <UploadButton
                                    onFileUpload={handleUploadFile}
                                    label={"Upload"}
                                    sx={{ width: '100%', my: 1, fontSize: 10 }}
                                    color="success"
                                    variant={'contained'}
                                // loading={loading}
                                />
                            }
                            {handleOpenSignatories &&
                                <ButtonCustom
                                    label={signButtonLabel(file)}
                                    sx={{
                                        width: onSharedView ? '47%' : '100%',
                                        borderRadius: '20px',
                                        my: 1, mr: 1,
                                        fontSize: 11
                                    }}
                                    startIcon={<DriveFileRenameOutlineOutlinedIcon />}
                                    variant="outlined"
                                    onClickBtn={handleOpenSignatories}
                                />
                            }
                            {handleCopyLink &&
                                <CopyToClipboard
                                    text={publicLink}
                                    onCopy={() => handleCopyLink(file)}
                                // onCopy={onCopy} text={ value }
                                >
                                    <Button
                                        sx={{ width: '30%', borderRadius: '20px', my: 1, mr: 1, fontSize: 11 }}
                                        startIcon={<ContentCopyIcon />}
                                        color="primary"
                                        variant="outlined"
                                        size={"large"}
                                    >
                                        {"Copy"}
                                    </Button>

                                </CopyToClipboard>
                            }

                            {handleShareFile &&
                                <ButtonCustom
                                    label={"Share"}
                                    sx={{ width: '48%', borderRadius: '20px', my: 1, fontSize: 11 }}
                                    startIcon={<WhatsAppIcon color="success" />}
                                    variant="outlined"
                                    color="success"
                                    onClickBtn={() => handleShareFile(file)}
                                />
                            }

                            {handleMarkSharing &&
                                <Button
                                    sx={{ width: '100%', mt: 2, textDecoration: "underline" }}
                                    startIcon={sharedForms.includes(file.FormName) ? <CheckBoxIcon color="success" /> : <CheckBoxOutlineBlankIcon color="success" />}
                                    color="success"
                                    onClick={() => handleMarkSharing(file)}
                                >
                                    {sharedForms.includes(file.FormName) ? "Shared to agent" : "Share to agent"}
                                </Button>
                            }
                        </>
                    }

                </FileCard>
                :
                <Grid xs={12} sm={6} md={4}>
                    <HorizontalFileCard
                        fileName={title}
                        fileIcon={fileIcon}
                        onTitleClick={handleViewFile}
                    >
                        {handleUploadFile && 
                            <UploadButton
                                sx={{ 
                                    m: 1,
                                    fontSize: 11
                                  }}
                                color="success"
                                label={fileExists === null ? "Loading..." : (fileExists ? "Re-upload the file" : "Upload file")}
                                onFileUpload={handleUploadFile}
                                variant={'contained'}
                                disabled={formMode === MODE.CLOSED}
                            />
                        }
                        {handleOpenSignatories && 
                            <ButtonCustom
                                label={signButtonLabel(file)}
                                sx={{ 
                                    m: 1 , 
                                    fontSize: 11
                                 }}
                                startIcon={<DriveFileRenameOutlineOutlinedIcon />}
                                variant="outlined"
                                onClickBtn={handleOpenSignatories}
                                disabled={formMode === MODE.CLOSED}
                            />
                        }
                        {handleDownloadFile &&
                            <ButtonCustom
                                label={'Download'}
                                sx={{
                                    // width: formMode === MODE.CLOSED ? '280px' : "33%",
                                    textDecoration: "underline",
                                    m: 1,
                                    fontSize: 11
                                }}
                                startIcon={< DownloadOutlinedIcon />}
                                variant="outlined"
                                color="error"
                                onClickBtn={handleDownloadFile}
                            />

                        }
                    </HorizontalFileCard>
                </Grid>
            }
    </>
    )
}

export default PDFCard;